import React from 'react';

import './main.css';
import Verification from "../verification/Verification";
import Summary from "../summary/Summary";
import SummarySwap from "../summary-swap/Summary-Swap";
import Confirmation from "../confirmation/Confirmation";
import CarnivalThings from "../carnival-things-toknow/Carnival-Things-ToKnow";
import Fulfillment from "../fulfillment/Fulfillment";
import PaymentView from "../payment-view/paymentView";
import ConfirmationView from "../confirmation-view/confirmationView";
import Error from "../error/error";
import IdleTimer from "react-idle-timer";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import CountDown from "../count-down/count-down";
import Helmet from "react-helmet/es/Helmet";
import {createStore} from 'redux';
import allReducers from '../reducers';
import {Provider} from 'react-redux';
import ReactGA from 'react-ga';
import NewSummary from '../redesignPages/New-Summary';
import PaymentDetails from '../payment-view/paymentDetails';
import ConfirmationDetails from '../confirmation-details/confirmationDetails';
// import PaymentConfirmation from '../paymentConfirmation/paymentConfirmation';
/* eslint-disable */
class Main extends React.Component {

    constructor(props) {
        super(props);
        this.DEFAULT_TIME_OUT_BEFORE_CONFIRMATION = 3000000;
        this.DEFAULT_TIME_OUT_AFTER_CONFIRMATION = 3600000;
        this.franchiseData = this.props.franchiseData;
        this.siteConfigData = this.props.siteConfigData;
        this.isSwapSite = this.props.isSwapSite;
        this.state = {
            booking: null,
            bonusOffers: null,
            hash: null,
            paymentConfirmation: null,
            error: null,
            timeOutBeforeConfirmation: this.DEFAULT_TIME_OUT_BEFORE_CONFIRMATION, // milliseconds...
            timeOutAfterConfirmation: this.DEFAULT_TIME_OUT_AFTER_CONFIRMATION, // milliseconds...
            initialRemainingTime: 600000,
            showCountDownUnder: 10000,
            showModal: false,
            activeComponentInMain: 'verification',
            sessionExpired: false,
            remainingTimeFunction: null,
            isConsentGiven: false,
            isAdScriptAdded: false
        }

        this.idleBeforeTimer = null;
        this.idleAfterTimer = null;
        this.onAction = this._onAction.bind(this);
        this.onActive = this._onActive.bind(this);
        this.onIdle = this._onIdle.bind(this);
        this.onIdleAfter = this._onIdleAfter.bind(this);
        this.sessionExpiredMessage = null;

        this.OnetrustActiveGroups =  window.OnetrustActiveGroups !== undefined ? window.OnetrustActiveGroups.split(',') : "";
    }

    _onAction = (e) => {
        //this.setState({isTimedOut: false});
    }

    _onActive = (e) => {
        //this.setState({isTimedOut: false});
    }

    _onIdle = (e) => {
        if (this.state.activeComponentInMain !== 'verification') {
            this.setState({showModal: true});
            this.setState({remainingTimeFunction: this.idleAfterTimer.getRemainingTime});
        }
    }

    _onIdleAfter = (e) => {
        if (this.state.activeComponentInMain !== 'verification') {
            this.setState({activeComponentInMain: 'verification'});
            this.setState({showModal: false});
            this.setState({booking: null});
            this.setState({paymentConfirmation: null});
            this.setState({error: null});
            this.setState({sessionExpired: true});
            window.scrollTo(0, 0);
        }
    }

    handleClose = () => {
        this.setState({showModal: false});
        this.idleBeforeTimer.reset();
        this.idleAfterTimer.reset();
    }
    
    getStoreAttValue = (attCode) => {
    	let storeAttributeValue='';
    	for(let i=0; i<this.props.siteConfigData.store.storeAttributes.length; i++){
    		if(this.props.siteConfigData.store.storeAttributes[i].attributeCode===attCode){
    			storeAttributeValue = this.props.siteConfigData.store.storeAttributes[i].attributeValue;
    		}
    	}
    	return storeAttributeValue;
    }
    
    getTemplatePropertyValue = (propertyName) => {
    	let templatePropertyValue='';
    	for(let j=0; j<this.props.siteConfigData.templateProperties.length; j++){
    		if(this.props.siteConfigData.templateProperties[j].propertyName===propertyName){
    			templatePropertyValue = this.props.siteConfigData.templateProperties[j].propertyValue;
    		}
    	}
    	return templatePropertyValue;
    }  
    
    getSitePropertyValue = (propertyName) => {
    	let sitePropertyValue='';
    	for(let k=0; k<this.props.siteConfigData.siteProperties.length; k++){
    		if(this.props.siteConfigData.siteProperties[k].propertyName===propertyName){
    			sitePropertyValue = this.props.siteConfigData.siteProperties[k].propertyValue;
    		}
    	}
    	return sitePropertyValue;
    }  
    
    wthGaAppGetCookie = (cname) => {
		let name = cname + "=";
		let ca = document.cookie.split(';');
		for(let i=0; i<ca.length; i++)  {
		  let c = ca[i].trim();
		  if (c.indexOf(name)===0) {
			  return c.substring(name.length,c.length);
			}
		  }
		return "";
    }
    
    wthGaAppSetCookie = (cname, cvalue, exdays) => {
		let d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		let expires = "expires="+d.toUTCString();
		document.cookie = cname + "=" + cvalue + "; " + expires + ";path=/;domain=." + window.location.hostname;
    }
    
    wthGaAppCreateDlCookie = (cname,cvalue) => {
		let expires = "";
		let date = new Date();
		let midnight = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
		expires = "; expires=" + midnight.toUTCString();
		document.cookie = cname + "=" + cvalue + expires + ";path=/;domain=." + window.location.hostname;
	}
    
    mobileCheck = () => {
    	  let check = false;
    	  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    	  return check;
    	};
    
	mobileAndTabletCheck = () => {
		  let check = false;
		  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		  return check;
		};
    
	 CallTracker = (category, action, label, value, noninteraction) => {
        if(label === "" || label === null) {
            label = "(not set)";
        } 

        var oneTrust = window.OnetrustActiveGroups;
         if ( this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N' && oneTrust && oneTrust.includes('C0004')) {
            ReactGA.event({ category: category, action: action, label: label, value: value })
         } else if (this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') === 'N') {
            ReactGA.event({ category: category, action: action, label: label, value: value })
         } else {
             console.log("off");    
         }

     }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.siteConfigData.store.storeCode === 'PLWEB' && this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N') {
            if (prevState.isConsentGiven !== this.state.isConsentGiven) {
                this.toggleScriptType();
            }
        }
    }

    loadScripts = () => {
        if (window.OneTrust && window.OnetrustActiveGroups && window.OnetrustActiveGroups.split(',').includes('C0004')) {
            this.addScript('https://www.googletagservices.com/tag/js/gpt.js', 'text/javascript');
        } else {
            this.addScript('https://www.googletagservices.com/tag/js/gpt.js', 'text/plain');
        }
        this.addAdScript();
    };

    addScript = (src, type) => {
        const script = document.createElement('script');
        script.src = src;
        script.type = type;
        script.className = 'optanon-category-C0004';
        script.async = true;
        document.head.appendChild(script);
    };

    addAdScript = () => {
        if (!this.state.isAdScriptAdded && window.OneTrust && window.OnetrustActiveGroups && window.OnetrustActiveGroups.split(',').includes('C0004')) {
            setTimeout(() => {
                window.googletag = window.googletag || {};
                window.googletag.cmd = window.googletag.cmd || [];
                const scriptPromoslot = document.createElement('script');
                scriptPromoslot.type = 'text/javascript';
                scriptPromoslot.innerHTML = `
                    googletag.cmd.push(function() {
                    googletag.defineSlot('/3102/priceline.dart/cruise_homepage_300x250_bottom', [300, 250], 'div-gpt-ad-1717615785308-0')
                        .addService(googletag.pubads());
                    googletag.pubads().enableSingleRequest();
                    googletag.enableServices();
                    });
                `;
    
                const adContainer = document.getElementById('div-gpt-ad-1717615785308-0');
                if (adContainer !== null) {
                    if (!this.state.isAdScriptAdded) {
                        adContainer.appendChild(scriptPromoslot);
                        window.googletag.cmd.push(function() { 
                            window.googletag.display("div-gpt-ad-1717615785308-0"); 
                        });
                        this.setState({ isAdScriptAdded: true});
                    }
    
                } 
            }, 1000)

        } else {
            return;
        }
    };
    
    checkCookieConsent = () => {
        const handleConsentChange = () => {
            const isCategoryConsented = window.OneTrust && window.OnetrustActiveGroups && window.OnetrustActiveGroups.split(',').includes('C0004');
            this.setState({
                isConsentGiven: isCategoryConsented,
            });
        };

        if (window.OneTrust && typeof window.OneTrust.OnConsentChanged === 'function') {
            window.OneTrust.OnConsentChanged(handleConsentChange);
            handleConsentChange(); // Check initial consent status
        }
    };
    
    toggleScriptType = () => {
        const scriptType = this.state.isConsentGiven ? 'text/javascript' : 'text/plain';
        this.changeScriptType('https://www.googletagservices.com/tag/js/gpt.js', scriptType);
        if (this.state.isConsentGiven && !this.state.isAdScriptAdded) {
            this.addAdScript();
        }
    };

    changeScriptType = (src, type) => {
        const scripts = document.querySelectorAll(`script[src="${src}"]`);
        scripts.forEach(script => {
            script.type = type;
        });
    };


	 componentDidMount = () => {
	var gaGTAGPageURL;
        if ( this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N') {
            const script = document.createElement("script");
            script.async = true;
            script.type = 'text/plain'
            script.className = 'optanon-category-C0004';
            script.src = `https://www.googletagmanager.com/gtag/js?id=${this.props.siteConfigData.trackingId}`;
            document.body.appendChild(script);
            if (this.OnetrustActiveGroups.includes('C0004')) {
                ReactGA.initialize(this.props.siteConfigData.trackingId);
                gaGTAGPageURL = window.location.protocol + "//" + window.location.hostname;
                // Track pageview
                ReactGA.pageview(gaGTAGPageURL);
 
            }

            if (this.props.siteConfigData.store.storeCode === 'PLWEB') {
                this.loadScripts();
                this.checkCookieConsent();
            }

        }
       
        if (this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') === 'N') {
            const script = document.createElement("script");
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtag/js?id=${this.props.siteConfigData.trackingId}`;
            document.body.appendChild(script);
            ReactGA.initialize(this.props.siteConfigData.trackingId);
            gaGTAGPageURL = window.location.protocol + "//" + window.location.hostname;
            // Track pageview
            ReactGA.pageview(gaGTAGPageURL);
        }
        
		 if(this.props.isSwapSite===true){
		 	
			setTimeout(function(){	
				
				//set content link focus function
				document.getElementById("skipToMainContent").addEventListener("click", function(){ document.getElementById("mainContent").focus();});
				//setResponsiveHeaderContent() function contents
				// JavaScript function to get entire magnolia desktop header and insert it into responsive footer container and reverse
	    		
				let windowWidth = 0;
				windowWidth = window.innerWidth;	
				
				if ( windowWidth < 1024) {			
					//responsive view
					if(document.body.contains(document.getElementById("HeaderBannerModule"))) {
						//header banner module
						if(document.body.contains(document.getElementById("responsiveHeaderBar_above"))) {
							//header banner module above logo
							let getHeaderContent = document.getElementById("HeaderBannerModule");
							document.getElementById("responsiveHeaderBar_above" ).appendChild(getHeaderContent);
						} else {
							//header banner module below nav
							if(document.body.contains(document.getElementById("responsiveHeader_below"))){
								let getHeaderContent2 = document.getElementById("HeaderBannerModule");
								document.getElementById("responsiveHeader_below").appendChild(getHeaderContent2);
							}
						}
					} 	
					//travelAdvisoryLink
					if(document.body.contains(document.getElementById("travelAdvisoryLink"))) {
						if(document.body.contains(document.getElementById("responsiveHeader_above"))){
							let getTravelAdvisoryLink = document.getElementById("travelAdvisoryLink");
							document.getElementById("responsiveHeader_above" ).appendChild(getTravelAdvisoryLink);
						}
					}
		    			
						
		    	}
		    	
				//setResponsiveFooterContent() function contents
				// JavaScript function to get entire magnolia desktop footer and insert it into responsive footer container and reverse
	    		
	    		windowWidth = 0;
	    		windowWidth = window.innerWidth;	
	    	
	    		if ( windowWidth < 1024) {
	    			//responsive view
	    			if(document.body.contains(document.getElementById("wthFooterModuleContainer"))) {
	    				//magnolia footer
	    				let gatherFooter = document.getElementById("wthFooterModuleContainer");
	    				let magFooter = document.getElementById( "responsiveMagFooter" )
	    				if(magFooter){
                            magFooter.appendChild(gatherFooter);
                            document.getElementById("fallBackSwapFooter").innerHTML = '';
                        }	    				
	    				
	    			} 
	    		}
	    			else {
	    			//desktop View
	    			if(document.body.contains(document.getElementById("wthFooterModuleContainer"))) {
	    				//magnolia footer			
	    				let gatherFooter2 = document.getElementById("wthFooterModuleContainer");
						let wthFooterWrap=document.getElementById("wthFooterWrap");
						if(wthFooterWrap){
	    				document.getElementById("wthFooterWrap").appendChild(gatherFooter2);
						}
	    			} 			
	    		}	
		    		
		    	
	    		
	    		//Vanilla script hack for half-development of old jquery-ui: needed for all links to have styles
				var elmLinks = document.getElementsByTagName('a')
				var length = elmLinks.length;
				for (var i = 0; i < length; i++) {
				  elmLinks[i].className = elmLinks[i].className + " ui-link";
				}
				
				//header show after app has loaded
				document.getElementById("reactHeader").style.display='block';
	    		
			}, 1000);
			  setTimeout(function() {window.scrollTo(0, 0);}, 500);
		 }
	 }
    myFunction = () => {
		  let d = new Date();
		  let n = d.getTime();
		  document.getElementById("demo").innerHTML = n;
		}

    sassStyle = () => {
        return this.props.siteConfigData.domainName.replace(/(\.|www|com|-)/g, '');

    }
    
    render = () => {
    	const store = createStore(allReducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
        return (
            <div>
                <Helmet>

                    <title>Customer Self Service</title>
                    { this.props.isSwapSite &&
                    <script src="/lib/javascript/desktop/jquery-3.5.1.min.js"></script> 
                    }
                    { this.props.isSwapSite &&
                    	<script src="/lib/javascript/react/headerReact.js"></script> 
                    }
                    { this.props.isSwapSite &&
                        <script src="/lib/javascript/desktop/wcag-dropdown.js?version=1.0.1"></script>
                    }
                    { this.props.isSwapSite && ["AAWEB","ARWEB","ACWEB"].includes(this.props.siteConfigData.store.storeCode) &&
                    	<script src="/lib/javascript/general/AALogin.js"></script>
                    }
                    { (this.props.isSwapSite &&  this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N' &&  this.OnetrustActiveGroups.includes('C0004')) ||
                        (this.props.isSwapSite &&  this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N' &&  this.OnetrustActiveGroups === '') ||
                        (this.props.isSwapSite &&  this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N' &&  this.OnetrustActiveGroups.join('') === '') ?
                        <script>
                            {`
                                //datalayer
                                window.dataLayer = window.dataLayer || [];
                                try{

                                    var zendeskPages = '` + this.getSitePropertyValue("ZENDESK_PAGES") + `';
                                    var zendeskPagesArray = zendeskPages.split(',');					   
                                    dataLayer.push({
                                    'gaProperty': '` + this.props.siteConfigData.trackingId + `',
                                    'pageID': 'CSS',						      
                                    'gaPartnerProperty': '` + this.getTemplatePropertyValue("PARTNER_GA_PROPERTY_ID") + `',					      
                                    'StoreCode': '` + this.props.siteConfigData.storeCode + `',
                                    'event': 'VirtualPageview',
                                    'virtualPageURL': 'gaVirtualPageURL',
                                    'virtualPagePath': '/css/login.do',
                                    'virtualPageTitle': 'Customer Self Service - Login', 
                                    'Mobile': '` + this.mobileCheck() + `',
                                    'MobileOrTablet': '` + this.mobileAndTabletCheck() + `',
                                    'sessionID': '` + this.wthGaAppGetCookie("WDVID") +`',
                                    'ZendeskID': '` + this.getSitePropertyValue("ZENDESK_ID") + `',
                                    'ZendeskDepartment': '` + this.getSitePropertyValue("ZENDESK_DEPARTMENT") + `',
                                    'ZendeskPages': zendeskPagesArray,
                                    'disableChat': '` + this.wthGaAppGetCookie("disableChat") + `'
                                    });
                                    
                                }
                                catch(error){
                                    //swallow error
                                }	
                            `}
                        </script> :  this.props.isSwapSite &&  this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') === 'N' &&
                        <script>
                            {`
                                //datalayer
                                window.dataLayer = window.dataLayer || [];
                                try{

                                    var zendeskPages = '` + this.getSitePropertyValue("ZENDESK_PAGES") + `';
                                    var zendeskPagesArray = zendeskPages.split(',');					   
                                    dataLayer.push({
                                    'gaProperty': '` + this.props.siteConfigData.trackingId + `',
                                    'pageID': 'CSS',						      
                                    'gaPartnerProperty': '` + this.getTemplatePropertyValue("PARTNER_GA_PROPERTY_ID") + `',					      
                                    'StoreCode': '` + this.props.siteConfigData.storeCode + `',
                                    'event': 'VirtualPageview',
                                    'virtualPageURL': 'gaVirtualPageURL',
                                    'virtualPagePath': '/css/login.do',
                                    'virtualPageTitle': 'Customer Self Service - Login', 
                                    'Mobile': '` + this.mobileCheck() + `',
                                    'MobileOrTablet': '` + this.mobileAndTabletCheck() + `',
                                    'sessionID': '` + this.wthGaAppGetCookie("WDVID") +`',
                                    'ZendeskID': '` + this.getSitePropertyValue("ZENDESK_ID") + `',
                                    'ZendeskDepartment': '` + this.getSitePropertyValue("ZENDESK_DEPARTMENT") + `',
                                    'ZendeskPages': zendeskPagesArray,
                                    'disableChat': '` + this.wthGaAppGetCookie("disableChat") + `'
                                    });
                                    
                                }
                                catch(error){
                                    //swallow error
                                }	
                            `}
                        </script>
                    }
                    
                    { !this.props.isSwapSite &&
                    <script>
                    
                        {`
                            window.dataLayer = window.dataLayer || [];
                            try{
                                dataLayer.push({
                                'gaProperty': '` + this.franchiseData.gaPropertyId + `',
                                'dimension37': '` + this.franchiseData.agencyName + `',
                                'dimension38': '` + this.franchiseData.agencyId + `',
                                'event': 'VirtualPageview',
                                'virtualPageURL': 'gaVirtualPageURL',
                                'virtualPagePath': '/css/login.do',
                                'virtualPageTitle': 'Customer Self Service - Login'                                
                            });
                            } catch(error){
                                //swallow error
                            }
                        `}
                    </script>
                    }

                  
                    {this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N' && this.OnetrustActiveGroups.includes('C0004') ? 
                        <script>
                            {`
                                function gtag(){
                                    dataLayer.push(arguments);
                                    var gaPathName = "";
                                }
                            `}
                        </script> : this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') === 'N' &&
                        <script>
                            {`
                                function gtag(){
                                    dataLayer.push(arguments);
                                    var gaPathName = "";
                                }
                            `}
                        </script>
                    }
    					
                        { !this.props.isSwapSite &&
                            <script>
                        
                        	{`
                            function changeGaPageviewUrl(){
                                var gaPathName =  window.location.pathname.split('?')[0];
                                //put the next line only for homepages to clean up the URL
                                gaPathName = gaPathName.replace("HomePage.html", "");
    
                                if (window.location.search) {
                                    var cleanURL = window.location.search;
                                    cleanURL = cleanURL.slice(1);
                                    var query = cleanURL;
                                    var argParam = false;
                                    for(var k=0; k < arguments.length; k++) {
                                        if (query.search(arguments[k]) > -1) {
                                            argParam = true;
                                            break;
                                        }
                                    }
        
                                    if (argParam) {
                                        var vars = query.split("&");
                                        for (var i = 0; i < vars.length; i++) {
                                            var pair = vars[i].split("=");
                
                                            for(var j=0; j < arguments.length; j++)
                                                if (pair[0].search(arguments[j]) > -1) {
                                                    vars[i] = pair[0] + "=";
                                                } 
                                        }
        
                                        return gaPathName + "?" + vars.join("&");
                                    } else {
                                        return gaPathName + "?" + query;
                                      }
                                } else {
                                    return gaPathName;
                                  }
                              }
                            `}
                            </script>
                        }
                        
                        { this.props.isSwapSite &&
                            <script>
                        
                        	{`
                        	var pageID= 'CSS';
                        	var pageId = 'CSS';
                            function changeGaPageviewUrl(){
                                var gaPathName =  window.location.pathname.split('?')[0];
    
                                if (window.location.search) {
                                    var cleanURL = window.location.search;
                                    cleanURL = cleanURL.slice(1);
                                    var query = cleanURL;
                                    var argParam = false;
                                    for(var k=0; k < arguments.length; k++) {
                                        if (query.search(arguments[k]) > -1) {
                                            argParam = true;
                                            break;
                                        }
                                    }
        
                                    if (argParam) {
                                        var vars = query.split("&");
                                        for (var i = 0; i < vars.length; i++) {
                                            var pair = vars[i].split("=");
                
                                            for(var j=0; j < arguments.length; j++)
                                                if (pair[0].search(arguments[j]) > -1) {
                                                    vars[i] = pair[0] + "=";
                                                } 
                                        }
        
                                        return gaPathName + "?" + vars.join("&");
                                    } else {
                                        return gaPathName + "?" + query;
                                      }
                                } else {
                                    return gaPathName;
                                  }
                              }
                            `}
                            </script>
                        }
                        
                        
                        { !this.props.isSwapSite &&
                            <script>
                            {`
                            
                            var gaGTAGPageURL = window.location.protocol + "//" + window.location.hostname + changeGaPageviewUrl("email", "zip", "zipcode", "shoppingZipCode");
                            var gaPathName =  window.location.pathname.split('?')[0];
                            
                            gtag('js', new Date());
                            gtag('config', 'UA-20449983-5',{ 
                                'send_page_view': false,
                                'page_location': gaGTAGPageURL,
                                'page_path':gaPathName
                            });
                            `}
                            </script>
                        }
                        
                        { this.props.isSwapSite && this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N' && this.OnetrustActiveGroups.includes('C0004') ?
                            <script>
                                {`                     
                                    var gaGTAGPageURL = window.location.protocol + "//" + window.location.hostname + changeGaPageviewUrl("email", "zip", "zipcode", "shoppingZipCode");                   

                                    gtag('js', new Date());                    
                                    var gaUniversalPropertyId = '` + this.props.siteConfigData.trackingId + `';	
                                    var gaUniversalSiteEndorsement = "` + this.props.siteConfigData.endorsement + `";
                                `}
                            </script> : this.props.isSwapSite && this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') === 'N' &&
                            <script>
                                {`                           
                                    var gaGTAGPageURL = window.location.protocol + "//" + window.location.hostname + changeGaPageviewUrl("email", "zip", "zipcode", "shoppingZipCode");                
                                    gtag('js', new Date());                
                                    var gaUniversalPropertyId = '` + this.props.siteConfigData.trackingId + `';	
                                    var gaUniversalSiteEndorsement = "` + this.props.siteConfigData.endorsement + `";
                                `}
                            </script>
                        }

                        {!this.props.isSwapSite &&
                        	<script>
                        	{`

                            function CallTracker(category, action, label, value, noninteraction) {
                            console.log("tracker function " + category);
                                if(label == "" || label == null) {
                                    label = "(not set)";
                                } 
                                gtag('event', action, {
                                    'event_category': category,
                                    'event_label': label,
                                    'value': value
                                });
                            }

                            function CallTrackerNonInteraction(category, action, label, value, noninteraction) {
                                if(label == "" || label == null) {
                                    label = "(not set)";
                                }
                                gtag('event', action, {
                                    'event_category': category,
                                    'event_label': label,
                                    'value': value,
                                    'non_interaction': true
                                });
                            }
                            
	                       function CallTrackerServerError(category, action, label, value, noninteraction) {	
						   		if(label === "" || label === null) {
						   			label = "(not set)";			
								}	   		
						   		gtag('event', action, {
						  		  'event_category': category,
						  		  'event_label': label,
						  		  'value': value
						  		});	 		
						    }
					
							function CallTrackerClientError(category, action, label, value, noninteraction) {	
						    	if(label === "" || label === null) {
						    		label = "(not set)";			
								}     	
								gtag('event', action, {
								  'event_category': category,
								  'event_label': label,
								  'value': value
								});
							}
                        `}
                    </script>
                    }

                        { this.props.isSwapSite &&
                            <script>
                        		{`
                        		 function setGACustomVar(slot,varName,varValue,scope) {
							    	pageTracker._setCustomVar(slot,varName,varValue,scope); 
							    }    
                        		`}
                        	</script>
                        }
                    { !this.props.isSwapSite &&
                        <script>
                    		{`
                    
                            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                            '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                            })(window,document,'script','dataLayer','` + this.getTemplatePropertyValue("GOOGLETAG_MANAGER_SHARED_ID") + `');
                    		`}
                    		</script>
                    }
                    
                    { this.props.isSwapSite &&
                        <script>
		                    {`
		                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
							new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
							j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
							'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
							})(window,document,'script','dataLayer','` + this.getTemplatePropertyValue("GOOGLETAG_MANAGER_SHARED_ID") + `');

							
		                    `}
                    	</script>
                    }
                    
                    { this.props.isSwapSite && this.getTemplatePropertyValue("GOOGLETAG_MANAGER_ACTIVE")==='Y' &&
                        <script>
		                    {`
		                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
							new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
							j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
							'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
							})(window,document,'script','dataLayer','` + this.getTemplatePropertyValue("GOOGLETAG_MANAGER_ACCOUNT") + `');
		                    `}
                    	</script>
                    }

                    { this.props.isSwapSite && this.getTemplatePropertyValue("GOOGLETAG_MANAGER_PARTNER_ACTIVE")==='Y' &&
                        <script>
		                    {`
		                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
							new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
							j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
							'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
							})(window,document,'script','dataLayer','` + this.getTemplatePropertyValue("GOOGLETAG_MANAGER_PARTNER_ID") + `');
		                    `}
                    	</script>
                    }
                    
                    { this.props.isSwapSite && this.getTemplatePropertyValue("PARTNER_GA_PROPERTY_ENABLED")==='Y' &&
                        <script>
		                    {`
		                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
							new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
							j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
							'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
							})(window,document,'script','dataLayer','GTM-MQXW4QQ');
		                    `}
                    	</script>
                    }
                    
                    { this.props.isSwapSite===true &&                   	
                    	<link rel="shortcut icon" href={"/images_unique/" + this.props.siteConfigData.storeCode + "/favicon.ico"} type="image/x-icon" />
                    }
                    { this.props.isSwapSite===true &&   
                    	<link type="text/css" rel="stylesheet" href={"/includes/desktop/css/desktop_" + this.props.siteConfigData.stylesheet + ".css?version=1.0.1"} />
                    }
                    { this.getSitePropertyValue("DOTCMS_SHOPPING_HEADER") === 'Y' &&
                    	<link type="text/css" rel="stylesheet" href={"/includes/desktop/css/cms/wth_cms.css"} />
                    }
                    { this.getSitePropertyValue("DOTCMS_SHOPPING_HEADER") === 'Y' && this.getSitePropertyValue("SHORTENED_DOMAIN") != null &&
                    	<link type="text/css" rel="stylesheet" href={"/includes/desktop/css/cms/wth_cms_" + this.getSitePropertyValue("SHORTENED_DOMAIN") + ".css"} />
                    }
                    { this.props.isSwapSite===true &&  
                        <link type="text/css" rel="stylesheet" href={"/includes/desktop/css/compiledSass/template_css_" + this.sassStyle() + ".css?version=1.0.1"} />
                    }

                    { this.props.isSwapSite===true && this.state.booking && this.isSwapSite && this.getSitePropertyValue('BCSS_HOME_REDESIGN') === 'Y' && 
                        <link type="text/css" rel="stylesheet" href={"/includes/desktop/css/compiledSass/template_css_shared.css?version=1.0.1"} />
                    }

                    { this.props.isSwapSite===true && this.state.booking && this.isSwapSite && this.getSitePropertyValue('BCSS_PAYMENT_PAGE_REDESIGN') === 'Y' && 
                        <link type="text/css" rel="stylesheet" href={"/includes/desktop/css/compiledSass/template_css_sharedPayment.css?version=1.0.1"} />
                    }

                    { this.props.isSwapSite===true &&   
                    	<meta content="text/html" charset="UTF-8" http-equiv="content-type" />
                    }
                    { this.props.isSwapSite===true &&   
                    	<meta name="viewport" content="width=device-width, initial-scale=1"/>
                    }
                    { this.props.isSwapSite===true &&   
                    	<meta name="theme-color" content="#000000"/>
                    }                   
                    { this.props.isSwapSite===true &&   
                    	<link href="//cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"  rel="stylesheet"/>
                    }
                    { this.props.isSwapSite===true &&   
                    	<link href="//stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet"/>
                    }
                    

                    </Helmet>
                    
                    
                    { this.props.isSwapSite===true &&  
		                //ajax spinner containers
                    <div id="ajaxSpinnerOuter" class="wth2-ajaxSpinnerOuter ui-loader" style={{display: 'none'}}>
						<div class="wth2-ajaxSpinnerWrapper">
							<div id="ajaxSpinner" class="wth2-ajaxSpinner"><div class="wth2-spinAnimation"></div><div id="ajaxLoadText" aria-live="polite" class="wth2-ajaxLoadText">loading</div></div>
						</div>
					</div>
					
                    }
		
				<div id="ajaxShim" class="wth2-dialogShim"></div> 	  
                <IdleTimer
                    ref={ref => {
                        this.idleBeforeTimer = ref
                    }}
                    element={document}
                    onActive={this.onActive}
                    onIdle={this.onIdle}
                    onAction={this.onAction}
                    debounce={250}
                    timeout={this.state.timeOutBeforeConfirmation}>
                    <IdleTimer
                        ref={ref => {
                            this.idleAfterTimer = ref
                        }}
                        element={document}
                        onActive={this.onActive}
                        onIdle={this.onIdleAfter}
                        onAction={this.onAction}
                        debounce={250}
                        timeout={this.state.timeOutAfterConfirmation}>
                    </IdleTimer>
                    <Modal show={this.state.showModal} onHide={this.handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Session Timeout</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="rea-countDownBold">
                                Due to inactivity, your session will expire in
                            </div>

                            <div className="rea-countDown">
                                <div className="rea-countDownNumContainer">
                                    <CountDown
                                        remainingTimeFunction={this.state.remainingTimeFunction}
                                        initialRemainingTime={this.state.initialRemainingTime}
                                        showCountDownUnder={this.state.showCountDownUnder}
                                        onReachNoRemainingTime={this.onReachNoRemainingTime}/>
                                </div>
                            </div>
                            <div className="rea-countDownText">
                                You will be automatically redirected to Access Your Reservation page.
                                <br/>
                                Please click <span className="rea-bold">“Continue”</span> to keep working.
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={this.handleClose}>
                                Continue
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    {
                        this.state.error &&
                        <div className="rea-Main">
                            <Error error={this.state.error} franchiseData={this.franchiseData} siteConfigData={this.siteConfigData} isSwapSite={this.isSwapSite}/>
                        </div>
                    }
                    {
                        this.state.paymentConfirmation &&
                        <div className="rea-Main">
                            <Confirmation paymentConfirmation={this.state.paymentConfirmation}
                                          onMakeAnotherPaymentSubmit={this.onMakeAnotherPaymentSubmit}/>
                        </div>
                    }

                    {
                        this.getSitePropertyValue('CSS_LOGIN_PAGE_REDESIGN') !== 'N' ?
                        
                            !this.state.booking && !this.state.paymentConfirmation && !this.state.error &&
                        
                            
                                <div className="wth3-login-container">
                                    
                                    {document.body.classList.add("wth2-body_" + this.siteConfigData.storeCode)}
                                    <div className="wth3-image-container">
                                        <img src="/includes/global/css/images/ship-image-box.png" alt="cruise ship on the sea" />
                                    </div>
                                    <Verification sessionExpired={this.state.sessionExpired} sessionExpiredMessage={this.sessionExpiredMessage} franchiseData={this.franchiseData} siteConfigData={this.siteConfigData} isSwapSite={this.isSwapSite}
                                                onBookingRetrieved={this.onBookingRetrieved} onChangeView={this.onChangeView} CallTracker={this.CallTracker}/>

                                </div> 
                                
                                :

                            !this.state.booking && !this.state.paymentConfirmation && !this.state.error &&
                        
                                <div className="rea-Main wth2-content">
                                    {
                                        this.state.sessionExpired &&
                                        <div ref={(input) => {
                                            this.sessionExpiredMessage = input;
                                        }} className="wth2-errorMessage rea-errorMessage">
                                            We’re sorry. Your session has expired. Please enter your booking details to access
                                            your reservation.
                                        </div>
                                    }
                                    {document.body.classList.add("wth2-body_" + this.siteConfigData.storeCode)}
                                    <Verification franchiseData={this.franchiseData} siteConfigData={this.siteConfigData} isSwapSite={this.isSwapSite}
                                                onBookingRetrieved={this.onBookingRetrieved} onChangeView={this.onChangeView} CallTracker={this.CallTracker}/>
                                </div>
                    }
                    
                    {
                        this.state.booking && !this.isSwapSite &&
                        <div className="rea-Main wth2-content">
                            <Summary onPaymentSubmit={this.onPaymentSubmit} onPaymentError={this.onPaymentError}
                                     booking={this.state.booking}
                                     hash={this.state.hash}
                                     franchiseData={this.franchiseData} siteConfigData={this.siteConfigData} isSwapSite={this.isSwapSite}/>
                            </div>
                    }
                    
                    {
                        this.state.booking && this.isSwapSite && this.getSitePropertyValue('BCSS_HOME_REDESIGN') === 'Y' && this.state.activeComponentInMain === 'new-summary' ?
                        <Provider store={store}>
	                        <div className="new-main wth3-cssContent" id='cssSummaryPage'>
	                           <NewSummary onPaymentSubmit={this.onPaymentSubmit} onPaymentError={this.onPaymentError}
		                            booking={this.state.booking}
		                            hash={this.state.hash}
		                            franchiseData={this.franchiseData} siteConfigData={this.siteConfigData} isSwapSite={this.isSwapSite} onChangeView={this.onChangeView} onChangeViewRedeem={this.onChangeViewRedeem} CallTracker={this.CallTracker}/>
	                        </div>
                        </Provider> : this.state.booking && this.isSwapSite && this.state.activeComponentInMain === 'summary-swap' && 
                        <Provider store={store}>
	                        <div className="rea-Main wth2-content">
	                           <SummarySwap onPaymentSubmit={this.onPaymentSubmit} onPaymentError={this.onPaymentError}
		                            booking={this.state.booking}
		                            hash={this.state.hash}
		                            franchiseData={this.franchiseData} siteConfigData={this.siteConfigData} isSwapSite={this.isSwapSite} onChangeView={this.onChangeView} onChangeViewRedeem={this.onChangeViewRedeem} CallTracker={this.CallTracker}/>
	                        </div>
                        </Provider>
                    }
                    {
                        this.state.booking && this.state.activeComponentInMain === 'fulfillment' &&
                        <div className="rea-Main wth2-content">
                           <Fulfillment booking={this.state.booking} hash={this.state.hash} bonusOffers={this.state.bonusOffers}
	                            franchiseData={this.franchiseData} siteConfigData={this.siteConfigData} isSwapSite={this.isSwapSite} onChangeView={this.onChangeView} CallTracker={this.CallTracker}/>
                        </div>
                    }
                    {
                        this.state.booking && this.state.activeComponentInMain === 'carnivalthings' &&
                        <div className="rea-Main wth2-content">
                           <CarnivalThings booking={this.state.booking} hash={this.state.hash} 
                           		franchiseData={this.franchiseData} siteConfigData={this.siteConfigData} isSwapSite={this.isSwapSite} onChangeView={this.onChangeView} CallTracker={this.CallTracker}/>
                        </div>
                    }
                    {
                        this.state.booking && this.state.activeComponentInMain === 'paymentview' && this.getSitePropertyValue('BCSS_PAYMENT_PAGE_REDESIGN') === 'Y' ?
                        <Provider store={store}>
                            <div className="new-main wth3-cssContent">
                                <PaymentDetails booking={this.state.booking} hash={this.state.hash}
                                    franchiseData={this.franchiseData} siteConfigData={this.siteConfigData} getSitePropertyValue={this.getSitePropertyValue} isSwapSite={this.isSwapSite} onChangeView={this.onChangeView} CallTracker={this.CallTracker} onChangeViewConfirm={this.onChangeViewConfirm} updateBooking={this.state.updateBooking}/>
                            </div>
                        </Provider> : this.state.booking && this.state.activeComponentInMain === 'paymentview' &&
                        <Provider store={store}>
                            <div className="rea-Main wth2-content">
                            <PaymentView booking={this.state.booking} hash={this.state.hash}
                                    franchiseData={this.franchiseData} siteConfigData={this.siteConfigData} getSitePropertyValue={this.getSitePropertyValue} isSwapSite={this.isSwapSite} onChangeView={this.onChangeView} CallTracker={this.CallTracker} onChangeViewConfirm={this.onChangeViewConfirm} updateBooking={this.state.updateBooking}/>
                            </div>
                        </Provider>
                    }
                    {
                        this.state.booking && this.state.activeComponentInMain === 'confirmation' && this.getSitePropertyValue('BCSS_PAYMENT_PAGE_REDESIGN') === 'Y' ?
                            <div className="new-main wth3-cssContent">
	                           <ConfirmationDetails booking={this.state.booking} hash={this.state.hash}
		                            franchiseData={this.franchiseData} siteConfigData={this.siteConfigData} isSwapSite={this.isSwapSite} onChangeView={this.onChangeView} CallTracker={this.CallTracker} makePaymentResponse={this.state.makePaymentResponse}/>
	                        </div> 
                            : this.state.booking && this.state.activeComponentInMain === 'confirmation' &&
	                        <div className="rea-Main wth2-content">
	                           <ConfirmationView booking={this.state.booking} hash={this.state.hash}
		                            franchiseData={this.franchiseData} siteConfigData={this.siteConfigData} isSwapSite={this.isSwapSite} onChangeView={this.onChangeView} CallTracker={this.CallTracker} makePaymentResponse={this.state.makePaymentResponse}/>
	                        </div>
                    }
                </IdleTimer>
            </div>
        );
    }

    onBookingRetrieved = (jsonBookingResponse, hash) => {
        this.setState({booking: jsonBookingResponse});
        this.setState({hash: hash});
        if(this.isSwapSite && this.getSitePropertyValue('BCSS_HOME_REDESIGN') === 'N'){
        	this.setState({activeComponentInMain: 'summary-swap'});
        } else if (this.isSwapSite && this.getSitePropertyValue('BCSS_HOME_REDESIGN') === 'Y') {
            this.setState({activeComponentInMain: 'new-summary'});
        }
        else{
        	this.setState({activeComponentInMain: 'summary'});
        }
        this.setState({error: null});
        this.setState({paymentConfirmation: null});
    }
    
    onChangeView = (newView, jsonBookingResponse, hash, updatedBookingResponse) => {
        var oneTrust;
        
        if (this.getSitePropertyValue('BCSS_HOME_REDESIGN') === 'Y') {
            if (newView === "summary-swapInsurance") {
                document.querySelector(".rea-Main")?.scrollIntoView();
            } else if (newView !== 'new-summary') {
                document.querySelector(".new-main")?.scrollIntoView();
            } else {
                if (this.getSitePropertyValue('BCSS_PAYMENT_PAGE_REDESIGN') === 'Y') {
                    document.querySelector(".new-main")?.scrollIntoView();
                } else {
                    document.querySelector(".rea-Main")?.scrollIntoView();
                }
            }
            let gaLabelChangeView = '';
            if(newView==='changeinfo'){
                gaLabelChangeView="Change Guest Information";
                }
            if(newView==='paymentview'){
                gaLabelChangeView="Make Safe and Secure Payments";
                try {
                    var oneTrust = window.OnetrustActiveGroups;
                    if ( this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N' && oneTrust && oneTrust.includes('C0004')) {
                        window.dataLayer.push({
                            'event': 'VirtualPageview',
                            'virtualPageURL': 'gaVirtualPageURL',
                            'virtualPagePath': '/css/guest/payment',
                            'virtualPageTitle': 'Customer Self Service'
        
                        });
                    } else if (this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') === 'N') {
                        window.dataLayer.push({
                            'event': 'VirtualPageview',
                            'virtualPageURL': 'gaVirtualPageURL',
                            'virtualPagePath': '/css/guest/payment',
                            'virtualPageTitle': 'Customer Self Service'
        
                        });
                    } else {
                        console.log("off");    
                    }
                
                } catch (error) {
                    //swallow error
                }
            }
            
            if(newView==='addinsurance'){
                gaLabelChangeView="Add Travel Insurance";
                try {
                    var oneTrust = window.OnetrustActiveGroups;
                    if ( this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N' && oneTrust && oneTrust.includes('C0004')) {
                        window.dataLayer.push({
                            'event': 'VirtualPageview',
                            'virtualPageURL': 'gaVirtualPageURL',
                            'virtualPagePath': '/css/guest/payment',
                            'virtualPageTitle': 'Customer Self Service'
        
                        });
                    } else if (this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') === 'N') {
                        window.dataLayer.push({
                            'event': 'VirtualPageview',
                            'virtualPageURL': 'gaVirtualPageURL',
                            'virtualPagePath': '/css/guest/payment',
                            'virtualPageTitle': 'Customer Self Service'
        
                        });
                    } else {
                        console.log("off");    
                    }
                
                } catch (error) {
                    //swallow error
                }
            } 
            if(newView==='fulfillment'){
                gaLabelChangeView="Redeem Bonus Offer";
            }  
            if(newView === "new-summary"){
                gaLabelChangeView="Return to Booking Summary";
            } 

            if(newView === "summary-swap"){
                gaLabelChangeView="Return to Booking Summary";
                newView = 'new-summary';
            } 

            if(newView==='summary-swapInsurance'){
                this.CallTracker("Customer Self Service", "Add Insurance", "Finish Adding Travel Insurance: No Thanks");
                gaLabelChangeView="Return to Booking Summary";
                newView = 'new-summary';
            } 
            this.CallTracker("Customer Self Service", "Booking Summary", gaLabelChangeView);
            if(newView==='addinsurance'){
                newView = 'paymentview';
            }
            this.setState({booking: jsonBookingResponse});
            this.setState({updateBooking: updatedBookingResponse});
            this.setState({hash: hash});
            this.setState({activeComponentInMain: newView});
            this.setState({error: null});
            this.setState({paymentConfirmation: null});
        } else {

            document.querySelector(".rea-Main").scrollIntoView();
            let gaLabelChangeView = '';
            if(newView==='changeinfo'){
                gaLabelChangeView="Change Guest Information";
                }
            if(newView==='paymentview'){
                gaLabelChangeView="Make Safe and Secure Payments";
                try {
                    var oneTrust = window.OnetrustActiveGroups;
                    if ( this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N' && oneTrust && oneTrust.includes('C0004')) {
                        window.dataLayer.push({
                            'event': 'VirtualPageview',
                            'virtualPageURL': 'gaVirtualPageURL',
                            'virtualPagePath': '/css/guest/payment',
                            'virtualPageTitle': 'Customer Self Service'
        
                        });
                    } else if (this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') === 'N') {
                        window.dataLayer.push({
                            'event': 'VirtualPageview',
                            'virtualPageURL': 'gaVirtualPageURL',
                            'virtualPagePath': '/css/guest/payment',
                            'virtualPageTitle': 'Customer Self Service'
        
                        });
                    } else {
                        console.log("off");    
                    }
                   
                } catch (error) {
                    //swallow error
                }
            }
            
            if(newView==='addinsurance'){
                gaLabelChangeView="Add Travel Insurance";
                try {
                    var oneTrust = window.OnetrustActiveGroups;
                    if ( this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') !== 'N' && oneTrust && oneTrust.includes('C0004')) {
                        window.dataLayer.push({
                            'event': 'VirtualPageview',
                            'virtualPageURL': 'gaVirtualPageURL',
                            'virtualPagePath': '/css/guest/payment',
                            'virtualPageTitle': 'Customer Self Service'
        
                        });
                    } else if (this.getSitePropertyValue('ONE_TRUST_SNIPPET_COOKIE_LOADER') === 'N') {
                        window.dataLayer.push({
                            'event': 'VirtualPageview',
                            'virtualPageURL': 'gaVirtualPageURL',
                            'virtualPagePath': '/css/guest/payment',
                            'virtualPageTitle': 'Customer Self Service'
        
                        });
                    } else {
                        console.log("off");    
                    }
                  
                } catch (error) {
                    //swallow error
                }
            } 
            if(newView==='fulfillment'){
                gaLabelChangeView="Redeem Bonus Offer";
            }  
            if(newView==='summary-swap'){
                gaLabelChangeView="Return to Booking Summary";
            } 
            if(newView==='summary-swapInsurance'){
                this.CallTracker("Customer Self Service", "Add Insurance", "Finish Adding Travel Insurance: No Thanks");
                gaLabelChangeView="Return to Booking Summary";
                newView = 'summary-swap';
            } 
            this.CallTracker("Customer Self Service", "Booking Summary", gaLabelChangeView);
            if(newView==='addinsurance'){
                newView = 'paymentview';
            }
            this.setState({booking: jsonBookingResponse});
            this.setState({updateBooking: updatedBookingResponse});
            this.setState({hash: hash});
            this.setState({activeComponentInMain: newView});
            this.setState({error: null});
            this.setState({paymentConfirmation: null});
        }
    }

    onChangeViewRedeem = (jsonBookingResponse, hash, jsonBonusOfferResponse) => {
    
        if (this.getSitePropertyValue('BCSS_HOME_REDESIGN') === 'Y') {
            document.querySelector(".new-main").scrollIntoView();
        }

    	this.CallTracker("Customer Self Service", "Booking Summary", "Redeem Bonus Offer")
        this.setState({booking: jsonBookingResponse});
    	this.setState({bonusOffers: jsonBonusOfferResponse});
        this.setState({hash: hash});
        this.setState({activeComponentInMain: "fulfillment"});
        this.setState({error: null});
        this.setState({paymentConfirmation: null});
    }
    
    onChangeViewConfirm = (jsonBookingResponse, jsonMakePaymentResponse) => {
    	this.CallTracker("Customer Self Service", "Booking Summary", "Confirmation");
        this.setState({booking: jsonBookingResponse});
    	this.setState({makePaymentResponse: jsonMakePaymentResponse});
        this.setState({activeComponentInMain: "confirmation"});
        this.setState({error: null});
        this.setState({paymentConfirmation: null});
    }
    onPaymentSubmit = (jsonPaymentResponse) => {
        this.setState({
            paymentConfirmation: {
                bookingNumber: this.state.booking.bookingId,
                totalWithOutInsurance: jsonPaymentResponse.bookingTotal,
                insuranceTotal: jsonPaymentResponse.insuranceTotal,
                paymentsReceived: jsonPaymentResponse.previousPayments,
                pendingPaymentTotal: jsonPaymentResponse.pendingPayments,
                remainingBalanceIncludingInsurance: jsonPaymentResponse.balanceDueWithInsurance,
                remainingBalanceExcludingInsurance: jsonPaymentResponse.balanceDueWithoutInsurance,
                finalPaymentDate: this.state.booking.finalPaymentDate,
                includeInsurance: jsonPaymentResponse.balanceDueWithInsurance !== jsonPaymentResponse.balanceDueWithoutInsurance,
                paymentAmount: jsonPaymentResponse.paymentAmount
            }
        });
        this.setState({booking: null});
        this.setState({error: null});
    }

    onReachNoRemainingTime = () => {
        this.onIdleAfter();
    }

    onPaymentError = (error) => {
        this.setState({booking: null});
        this.setState({paymentConfirmation: null});
        this.setState({error: error});
    }

    onMakeAnotherPaymentSubmit = () => {
        this.setState({booking: null});
        this.setState({paymentConfirmation: null});
        this.setState({error: null});
    }
}

export default Main;
